import React from 'react';
import { Resource, ResourceInfo, ResourceProps } from 'omni-package-react-core';
import getNotificationsApiRoot from '../../utils/getNotificationsApiRoot';

export const ActionRequiredResourceInfo: ResourceInfo = {
  name: '/App.features.notifications.actionsRequiredResource',
  url: `${getNotificationsApiRoot()}?Type=actionrequired&Audience=client`,
  dataDst: '/App.features.notifications.actionsRequired',
};

const ActionRequiredResource = <Data, Error = {}>({ ...props }: ResourceProps<Data, Error>) => (
  <Resource
    {...ActionRequiredResourceInfo}
    {...props}
  />
);

export default ActionRequiredResource;
